import * as React from 'react';
import {autobind} from '@shopify/javascript-utilities/decorators';
import numbersHelper from 'helpers';
import DesktopNewTabAnchor from 'components/DesktopNewTabAnchor';
import {Categories} from 'components/ShopDisplay';
import {Shop} from 'interfaces';
import {withI18n, WithI18nProps} from 'packages/@shopify/react-i18n';
import * as locales from '../../locales';
import ShopMetric from '../../../ShopMetric';

export interface Props {
  shortenRow?: boolean;
  shop: Shop;
}

type ComposedProps = WithI18nProps & Props;
class ShopRowComponent extends React.PureComponent<ComposedProps> {
  constructor(props: ComposedProps) {
    super(props);
  }

  getAnchorPath() {
    const {shop} = this.props;
    return `/shops/${shop.handle}`;
  }

  @autobind
  handleClick(event) {
    if (event.target.tagName === 'A') {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    window.open(this.getAnchorPath(), '_blank');

  }

  render() {
    const {
      shop,
      shortenRow,
      i18n,
    } = this.props;

    const {
      averageProfitPerMonth,
      featured,
      inventoryValue,
      isContest,
      sold,
      shopifyShopRecord,
      starterShop,
    } = shop;

    let ariaLabel = '';
    let bannerLabel = '';
    if (featured) {
      ariaLabel = i18n.translate('row.featured');
      bannerLabel = i18n.translate('row.featured');
    } else if (sold) {
      ariaLabel = i18n.translate('row.sold');
      bannerLabel = i18n.translate('row.sold');
    } else if (isContest) {
      ariaLabel = i18n.translate('row.contest');
      bannerLabel = i18n.translate('row.contest');
    } else {
      ariaLabel = i18n.translate('row.sale');
    }

    let starterShopCells: React.ReactChild | React.ReactChild[];
    if (starterShop) {
      starterShopCells = (
        <td colSpan={4} className="shop-row__starter-cell">
          <div className="shop-row__starter-indicator">
            {i18n.translate('row.starterStore')}
          </div>
        </td>
      );
    } else if (shortenRow) {
      starterShopCells = [(
        <td key="averageMonthlyRevenue">
          <ShopMetric
            currency
            monthByMonth={shopifyShopRecord.monthByMonthRevenue}
            value={shopifyShopRecord.averageMonthlyRevenue}
          />
        </td>
      ), (
        <td key={shopifyShopRecord.averageMonthlyTraffic}>
          <ShopMetric
            currency={false}
            monthByMonth={shopifyShopRecord.monthByMonthTraffic}
            value={shopifyShopRecord.averageMonthlyTraffic}
          />
        </td>
      ), (
        <td key={averageProfitPerMonth}>
          <ShopMetric
            currency
            monthByMonth={null}
            value={averageProfitPerMonth}
          />
        </td>
      )];
    } else {
      starterShopCells = [(
        <td key="averageMonthlyRevenue">
          <ShopMetric
            currency
            monthByMonth={shopifyShopRecord.monthByMonthRevenue}
            value={shopifyShopRecord.averageMonthlyRevenue}
          />
        </td>
      ), (
        <td key={shopifyShopRecord.averageMonthlyTraffic}>
          <ShopMetric
            currency={false}
            monthByMonth={shopifyShopRecord.monthByMonthTraffic}
            value={shopifyShopRecord.averageMonthlyTraffic}
          />
        </td>
      ), (
        <td key={averageProfitPerMonth}>
          <ShopMetric
            currency
            monthByMonth={null}
            value={averageProfitPerMonth}
          />
        </td>
      ), (
        <td key={inventoryValue}>
          <ShopMetric
            currency
            monthByMonth={null}
            value={inventoryValue}
          />
        </td>
      )];
    }

    const anchorPath = this.getAnchorPath();

    return (
      <tr key={shop.handle} aria-label={ariaLabel} onClick={this.handleClick}>
        {!shortenRow && (
          <td className="shop-row__featured">
            {bannerLabel && <span className="shop-banner">{bannerLabel}</span>}
          </td>
        )}
        <td className="shop-row__title">
          <p className="heading--truncated">
            <DesktopNewTabAnchor href={anchorPath}>
              <span className="shop-tile__title">{shop.title}</span>
            </DesktopNewTabAnchor>
            <br />
            <span className="shop-tile__url">
              <DesktopNewTabAnchor href={anchorPath}>
                {shop.isPrivate ? i18n.translate('urlHidden') : shop.shopDomain}
              </DesktopNewTabAnchor>
            </span>
          </p>
        </td>

        {!shortenRow && (
          <td>
            <Categories shop={shop} showOnlyIndustry />
          </td>
        )}

        <>{starterShopCells}</>
        <td className="shop-row__price-cell">
          <DesktopNewTabAnchor
            href={anchorPath}

          >
            <span className="currency-symbol">$</span>
            {numbersHelper.truncateValue(shop.salePrice, 2)}
            <span className="currency-name">&nbsp;{i18n.translate('usd')}</span>
          </DesktopNewTabAnchor>
        </td>
      </tr>
    );
  }
}

const ShopRow = withI18n({
  id: 'ShopTable',
  fallback: locales.en,
})(ShopRowComponent);

export {ShopRow, ShopRowComponent};
export default ShopRow;
